import React from 'react';
import styled from 'styled-components';
import FocusLock from 'react-focus-lock';
import * as colors from 'src/styles/colors';
import Logo from 'src/assets/images/tipo_logo.png';
import RightNavIconMsg from 'src/assets/icon/menu_message.svg';
import RightNavIconMail from 'src/assets/icon/menu_mail.svg';
import { useModalStore } from 'src/hooks/useStore';
import InformModal from 'src/components/contents/Inform/InformModal';

import { useLocation, useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { modalZIndex } from 'src/styles/globalStyle';
import { globalComponents } from 'src/types/globalTypes';

const Wrapper = styled.div`
  position: fixed;
  z-index: ${modalZIndex};
  text-align: center;
  padding: 2rem 2rem 2rem 2rem;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(3px);
  background-color: rgba(255, 255, 255, 0.9);
  color: #263237;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
`;
const IconWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 21px;
  margin: 15px;
`;
const Header = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 54px;
`;
const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const LogoIcon = styled.img`
  height: 40px;
`;
const LogoText = styled.span`
  font-size: 16px;
  line-height: 23px;
  color: ${colors.BlueGray_700};
  padding-left: 12px;
`;
const Body = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-left: 1rem;
`;
const Item = styled.div<{ color: string; isActive: boolean }>`
  display: flex;
  text-align: center;
  padding-bottom: 35px;
  > span {
    color: ${(props) => (props.isActive ? props.color : colors.BlueGray_800)};
  }
`;
const ItemText = styled.span`
  font-size: 18px;
  line-height: 26px;
  color: ${colors.BlueGray_800};
  margin: auto;
  cursor: pointer;
`;
const Demarcation = styled.div`
  width: 15rem;
  border-top: 1px solid ${colors.primaryBlue_200};
  margin-bottom: 24px;
`;
const LinkItem = styled.div`
  display: flex;
  margin-bottom: 24px;
  margin-left: 15%;
  line-height: 26px;
  cursor: pointer;
`;

const LinkIconWrapper = styled.div`
  min-width: 40px;
`;
const LinkIcon = styled.img`
  min-width: 26px;
  min-height: 18px;
  display: inline-block;
  vertical-align: middle;
`;
const LinkText = styled.div`
  font-style: normal;
  font-weight: normal;
  color: ${colors.BlueGray_800};
  padding-left: 7px;
  font-size: 18px;
`;

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * 行動版清單。
 */
const MobileMenu: React.FC<IProps> = ({ isOpen, onClose }) => {
  const setActiveModal = useModalStore((state) => state.setActiveModal);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  function handleNavigation(path: string) {
    navigate(path);
    onClose();
  }
  
  const handleKeyDown = (
    e: React.KeyboardEvent<Element>, 
    callback: () => void
  ): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback();
    }
  };

  return isOpen ? (
    <Wrapper>
	<FocusLock returnFocus>
      <Header>
        <LogoWrapper onClick={() => handleNavigation(process.env.PUBLIC_URL === '' ? "/" : process.env.PUBLIC_URL)}>
          <LogoIcon src={Logo} alt="經濟部智慧財產局權證查詢系統 LOGO" />
          <LogoText>權證查詢系統</LogoText>
        </LogoWrapper>
        <IconWrapper>
          <FaTimes tabIndex={0} role="button" onClick={onClose} size={20} onKeyDown={(e) => handleKeyDown(e, onClose)}/>
        </IconWrapper>
      </Header>
      <Body>
        <Item
          color={globalComponents.P.color.seventh}
          isActive={pathname.startsWith(process.env.PUBLIC_URL + '/patentRights')}
          onClick={() => handleNavigation(process.env.PUBLIC_URL + '/patentRights')}
		  tabIndex={0}
		  role="button"
		  onKeyDown={(e) => handleKeyDown(e, () => handleNavigation(process.env.PUBLIC_URL + '/patentRights'))}
        >
          <ItemText>專利權證</ItemText>
        </Item>
        <Item
          color={globalComponents.T.color.seventh}
          isActive={pathname.startsWith(process.env.PUBLIC_URL + '/trademarkRights')}
          onClick={() => handleNavigation(process.env.PUBLIC_URL + '/trademarkRights')}
		  tabIndex={0}
		  role="button"
		  onKeyDown={(e) => handleKeyDown(e, () => handleNavigation(process.env.PUBLIC_URL + '/trademarkRights'))}
        >
          <ItemText>商標權證</ItemText>
        </Item>
        <Item
          color={globalComponents.C.color.fifth}
          isActive={pathname.startsWith(process.env.PUBLIC_URL + '/certificate')}
          onClick={() => handleNavigation(process.env.PUBLIC_URL + '/certificate/verify')}
		  tabIndex={0}
		  role="button"
		  onKeyDown={(e) => handleKeyDown(e, () => handleNavigation(process.env.PUBLIC_URL + '/certificate/verify'))}
        >
          <ItemText>電子證書</ItemText>
        </Item>

        <Demarcation />
        <LinkItem tabIndex={0} role="button" onClick={() => handleNavigation(process.env.PUBLIC_URL + '/patentRights/direction')} onKeyDown={(e) => handleKeyDown(e, () => handleNavigation(process.env.PUBLIC_URL + '/patentRights/direction'))}>
          <LinkIconWrapper>
            <LinkIcon src={RightNavIconMsg} alt="" />
          </LinkIconWrapper>
          <LinkText>操作說明</LinkText>
        </LinkItem>
		
		<LinkItem tabIndex={0} role="button" onClick={() => handleNavigation(process.env.PUBLIC_URL + '/sitemap')} onKeyDown={(e) => handleKeyDown(e, () => handleNavigation(process.env.PUBLIC_URL + '/sitemap'))}>
          <LinkIconWrapper>
            <LinkIcon src={RightNavIconMsg} alt="" />
          </LinkIconWrapper>
          <LinkText>網站導覽</LinkText>
        </LinkItem>
		
        <LinkItem
          onClick={() => {
            setActiveModal(<InformModal />);
            onClose();
          }}
		  tabIndex={0}
		  role="button"
		  onKeyDown={(e) => handleKeyDown(e, () => {
		              setActiveModal(<InformModal />);
		              onClose();
		            })}
        >
          <LinkIconWrapper>
            <LinkIcon src={RightNavIconMail} alt="" />
          </LinkIconWrapper>
          <LinkText>資料錯誤通報</LinkText>
        </LinkItem>
      </Body>
	</FocusLock>
    </Wrapper>
  ) : (
    <></>
  );
};

export default MobileMenu;
